import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { FileUploadCell } from 'components'
import { AttachmentInformationContainer, AttachmentDisplayContainer } from './styled'
import r from 'reactotron-react-js'

const AttachmentInformation = (props) => {
  const { valueForm={}, change, isDisplay=false } = props
  const [showAttachmentInformation, setShowAttachmentInformation] = useState(true)
  // r.log({valueForm})
  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Attachment'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowAttachmentInformation(!showAttachmentInformation) }>
            {showAttachmentInformation ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showAttachmentInformation}>
        <CardContent>
          {
            editableForm() ?
              <AttachmentInformationContainer>
                <div className='rowFields'>
                  <Field 
                    name='BG01' 
                    label='Bank Guarantee' 
                    require 
                    editable={editableForm()} 
                    replaceUpload
                    clearFiles={() => {
                      change('attachment01', [])
                    }}
                    showOldFile
                    oldFiles={valueForm.attachment01 || []}
                    removeOldFiles={(index, documentCode) => {
                      var clone = [...valueForm.attachment01]
                      clone.splice(index, 1)
                      change('attachment01', [...clone])
                    }}
                    type={type.file} 
                    component={FieldInput} />
                  <Field 
                    name='BG02' 
                    label='Other' 
                    editable={editableForm()} 
                    oldFiles={valueForm.attachment02 || []}
                    showOldFile
                    removeOldFiles={(index, documentCode) => {
                      var clone = [...valueForm.attachment02]
                      clone.splice(index, 1)
                      change('attachment02', [...clone])
                    }}
                    type={type.file} 
                    component={FieldInput} />
                </div>
              </AttachmentInformationContainer> :
              <AttachmentInformationContainer style={{ flexDirection: 'row' }}>
                <AttachmentDisplayContainer>
                  <div className='title'>Bank Guarantee</div>
                  {
                    (valueForm.attachment01 || []).length === 0 ?
                    <div className='emptyFile'>No file uploaded.</div> : 
                    (valueForm.attachment01 || []).map(a =>
                      <FileUploadCell 
                        key={a.name}
                        fileName={a.originalFilename}
                        fileSize={a.size}
                        urlPath={a.urlPath||null} 
                        deletable={false}
                      />
                    )
                  }
                </AttachmentDisplayContainer>
                <AttachmentDisplayContainer>
                  <div className='title'>Other</div>
                  {
                    (valueForm.attachment02 || []).length === 0 ?
                    <div className='emptyFile'>No file uploaded.</div> : 
                    (valueForm.attachment02 || []).map(a =>
                      <FileUploadCell 
                        key={a.name}
                        fileName={a.originalFilename}
                        fileSize={a.size}
                        urlPath={a.urlPath||null} 
                        deletable={false}
                      />
                    )
                  }
                </AttachmentDisplayContainer>
              </AttachmentInformationContainer>
          }
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
  })
}
  
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentInformation)